import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_TRANSPORT_SUPPLIER_RESET = 'PUT_TRANSPORT_SUPPLIER_RESET';
export const PUT_TRANSPORT_SUPPLIER_LOADING = 'PUT_TRANSPORT_SUPPLIER_LOADING';
export const PUT_TRANSPORT_SUPPLIER_SUCCESS = 'PUT_TRANSPORT_SUPPLIER_SUCCESS';
export const PUT_TRANSPORT_SUPPLIER_REJECT = 'PUT_TRANSPORT_SUPPLIER_REJECT';

//* ACTIONS ------------------------------------------------
export const putTransportSupplierReset = () => ({ type: PUT_TRANSPORT_SUPPLIER_RESET });
export const putTransportSupplierLoading = () => ({ type: PUT_TRANSPORT_SUPPLIER_LOADING });
export const putTransportSupplierSuccess = (payload) => ({ type: PUT_TRANSPORT_SUPPLIER_SUCCESS, payload });
export const putTransportSupplierReject = (payload) => ({ type: PUT_TRANSPORT_SUPPLIER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putTransportSupplierRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/api/TransportSuppliers`, options);
};


